import { render, staticRenderFns } from "./inventoryValueSummaryList.vue?vue&type=template&id=7a2f9d54&"
import script from "./inventoryValueSummaryList.vue?vue&type=script&lang=js&"
export * from "./inventoryValueSummaryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports